// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-info {
  background: #F3F3F3;
}

.container-all {
  height: 100vh;
}
.container-all .wrapper-left {
  display: flex;
  justify-content: center;
  align-self: center;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.container-all .wrapper-left ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.container-all.wrapper-info {
  overflow: auto;
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.container-all.wrapper-info ion-button {
  width: 100%;
}
.container-all.wrapper-info .header-title {
  margin-top: 50px;
  text-align: center;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  text-transform: capitalize;
}
.container-all.wrapper-info .title-section {
  width: 100%;
}
.container-all.wrapper-info .title-section h3 {
  text-align: center;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
}
.container-all.wrapper-info ion-card {
  margin: 20px 0px;
  padding: 12px;
  border-radius: var(--custom-border-radius);
  text-align: initial;
  --color: var(--ion-color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
  box-shadow: 0px 0px 45px 0px rgba(0, 0, 0, 0.1019607843);
}
.container-all.wrapper-info ion-card ion-card-header {
  background: white;
  color: var(--ion-color-black);
  padding: 0;
  padding-bottom: 8px;
  border-bottom: 0.3px solid rgba(126, 167, 105, 0.4509803922);
}
.container-all.wrapper-info ion-card ion-card-header .separator {
  margin-block: 20px;
}
.container-all.wrapper-info ion-card ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  text-transform: none;
}
.container-all.wrapper-info ion-card ion-card-content {
  border-top: 0.3px solid rgba(126, 167, 105, 0.4509803922);
  padding: 10px 0px 0px 0px;
  line-break: auto !important;
}
.container-all.wrapper-info ion-card ion-card-content:first-of-type {
  border: none;
}
.container-all.wrapper-info ion-card ion-card-content .padding-card {
  padding: 10px;
}
.container-all.wrapper-info ion-card ion-card-title {
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
  font-size: 18px;
}
.container-all.wrapper-info ion-card .icon-edit {
  zoom: 1.3;
}
.container-all.wrapper-info ion-card ion-col {
  padding: 5px 0px;
  color: var(--ion-color-secondary);
  font-size: 14px;
}
.container-all.wrapper-info ion-card .left-col {
  text-align: left;
  font-family: AppFontBold, sans-serif;
}
.container-all.wrapper-info ion-card .right-col {
  font-family: AppFont, sans-serif;
  text-align: right;
}
.container-all.wrapper-info ion-card .right-col.bold {
  font-family: AppFontBold, sans-serif;
}

.header-sliders {
  display: flex;
  justify-content: space-between;
  padding: 20px 0px;
}
.header-sliders .step {
  width: 33%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.header-sliders .step .line {
  width: 100%;
  height: 5px;
  background-color: #D9D9D9;
}
.header-sliders .step .line.selected {
  background-color: var(--ion-color-primary);
  animation: pulse 2s infinite;
}
.header-sliders .step p {
  padding-top: 10px;
}

@keyframes pulse {
  0%, 100% {
    background-color: var(--ion-color-primary);
    opacity: 1;
  }
  50% {
    background-color: var(--ion-color-primary);
    opacity: 0.5;
  }
}
.delivery-steps {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.delivery-steps__item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.delivery-steps__item ion-icon {
  width: 100px;
  height: 100px;
}
.delivery-steps__item p, .delivery-steps__item h3, .delivery-steps__item h5 {
  color: var(--ion-color-secondary);
  padding: 10px;
}
.delivery-steps__item p {
  font-family: AppFont;
  padding: 0px;
}
.delivery-steps__item h3, .delivery-steps__item h5 {
  font-family: AppFontBold, sans-serif;
}
.delivery-steps__item p {
  font-size: 12px;
}
.delivery-steps__item h5 {
  font-size: 16px;
}
.delivery-steps__item h3 {
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
}
.delivery-steps .map-block {
  min-height: 0px;
  opacity: 0;
  z-index: -1;
  max-height: 0px;
  position: relative;
}
.delivery-steps .map-block .show-time {
  position: absolute;
  top: 50px;
  background: white;
  padding: 10px 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
}
.delivery-steps .map-block .status-show {
  position: absolute;
  bottom: 50px;
  background: white;
  padding: 10px 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
}
.delivery-steps .map-block.hide-item {
  min-height: 400px;
  max-height: 400px;
  opacity: 1;
  z-index: 1;
}

.map-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 30px;
  overflow: hidden;
}

.map-frame {
  border: 2px solid black;
  height: 100%;
}

#map-item {
  height: 100%;
}

.verification-code {
  padding: 18px 12px !important;
  border: 1px solid #ED6958;
}
.verification-code ion-row:first-child {
  font-family: AppFontBold, sans-serif;
}
.verification-code ion-row {
  margin-bottom: 6px;
  text-align: center;
}
.verification-code div {
  min-width: 160px;
  width: 55%;
  max-width: 240px;
  border: 1px solid #CBD5E1;
  border-radius: 10px;
  margin: 0 auto;
  padding: 10px;
  letter-spacing: 5px;
  font-size: 20px;
  font-family: AppFontBold, sans-serif;
  text-align: center;
  color: var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAGA;EACC,aAAA;AAAD;AACC;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AACF;AAAE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAEH;AAIC;EACC,cAAA;EACA,aAAA;EAKA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AANF;AADE;EACC,WAAA;AAGH;AAIE;EACC,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,0BAAA;AAFH;AAIE;EACC,WAAA;AAFH;AAGG;EACC,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,eAAA;AADJ;AAIE;EACC,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EAEA,+BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;EACA,wDAAA;AAHH;AAIG;EACC,iBAAA;EACA,6BAAA;EACA,UAAA;EACA,mBAAA;EAIA,4DAAA;AALJ;AAEI;EACC,kBAAA;AAAL;AAII;EACC,yBAAA;EACA,gBAAA;EACA,oBAAA;AAFL;AAKG;EACC,yDAAA;EAEA,yBAAA;EACA,2BAAA;AAJJ;AAKI;EACC,YAAA;AAHL;AAKI;EACC,aAAA;AAHL;AAMG;EACC,oCAAA;EACA,iCAAA;EACA,eAAA;AAJJ;AAOG;EACC,SAAA;AALJ;AAOG;EACC,gBAAA;EACA,iCAAA;EACA,eAAA;AALJ;AAOG;EACC,gBAAA;EACA,oCAAA;AALJ;AAQG;EACC,gCAAA;EACA,iBAAA;AANJ;AAOI;EACC,oCAAA;AALL;;AAWA;EACC,aAAA;EACA,8BAAA;EACA,iBAAA;AARD;AASC;EACC,UAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAPF;AAQE;EACC,WAAA;EACA,WAAA;EACC,yBAAA;AANJ;AAQG;EACC,0CAAA;EAEA,4BAAA;AAPJ;AAWE;EACC,iBAAA;AATH;;AAaA;EACC;IACE,0CAAA;IACA,UAAA;EAVD;EAYD;IACE,0CAAA;IACA,YAAA;EAVD;AACF;AAYA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAVD;AAWC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AATF;AAUE;EACC,YAAA;EACA,aAAA;AARH;AAUE;EACC,iCAAA;EACA,aAAA;AARH;AAWE;EACC,oBAAA;EACA,YAAA;AATH;AAWE;EACC,oCAAA;AATH;AAWE;EACC,eAAA;AATH;AAWE;EACC,eAAA;AATH;AAWE;EACC,eAAA;EACA,yBAAA;EACA,kBAAA;AATH;AAYC;EACC,eAAA;EAEA,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAXF;AAYE;EACC,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,oCAAA;EACA,iCAAA;AAVH;AAYE;EACC,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,oCAAA;EACA,iCAAA;AAVH;AAYE;EACC,iBAAA;EACA,iBAAA;EACA,UAAA;EACD,UAAA;AAVF;;AAeA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AAZD;;AAeE;EACD,uBAAA;EACA,YAAA;AAZD;;AAeE;EACD,YAAA;AAZD;;AAiBA;EACC,6BAAA;EACA,yBAAA;AAdD;AAeC;EACC,oCAAA;AAbF;AAeC;EACC,kBAAA;EACA,kBAAA;AAbF;AAeC;EACC,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,iCAAA;AAbF","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper-info {\n\tbackground: #F3F3F3;\n}\n.container-all {\n\theight: 100vh;\n\t.wrapper-left {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-self: center;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\toverflow: auto;\n\t\tion-img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t\t// background: url('') no-repeat center center / 105% 105%;\n\t\t// background-size: cover;\n\t\t// background-position: center;\n\t}\n\t&.wrapper-info  {\n\t\toverflow: auto;\n\t\tpadding: 20px;\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t}\n\t\t\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-direction: column;\n\t\t.header-title {\n\t\t\tmargin-top: 50px;\n\t\t\ttext-align: center;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\ttext-transform: capitalize;\n\t\t}\n\t\t.title-section {\n\t\t\twidth: 100%;\n\t\t\th3 {\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 18px;\n\t\t\t}\n\t\t}\n\t\tion-card {\n\t\t\tmargin: 20px 0px ;\n\t\t\tpadding: 12px;\n\t\t\tborder-radius: var(--custom-border-radius);\n\t\t\ttext-align: initial;\n\t\t\n\t\t\t--color: var(--ion-color-black);\n\t\t\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\t\t\toverflow: auto;\n\t\t\tword-break: break-word;\n\t\t\tbox-shadow: 0px 0px 45px 0px #0000001A;\n\t\t\tion-card-header {\n\t\t\t\tbackground: white;\n\t\t\t\tcolor: var(--ion-color-black);\n\t\t\t\tpadding: 0;\n\t\t\t\tpadding-bottom: 8px;\n\t\t\t\t.separator {\n\t\t\t\t\tmargin-block: 20px;\n\t\t\t\t}\n\t\t\t\tborder-bottom: 0.3px solid #7EA76973;\n\t\t\n\t\t\t\tion-button {\n\t\t\t\t\t--background: transparent;\n\t\t\t\t\t--color: #54504c;\n\t\t\t\t\ttext-transform: none;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-content {\n\t\t\t\tborder-top: 0.3px solid #7EA76973;\n\n\t\t\t\tpadding: 10px 0px 0px 0px;\n\t\t\t\tline-break: auto !important;\n\t\t\t\t&:first-of-type {\n\t\t\t\t\tborder: none;\n\t\t\t\t}\n\t\t\t\t.padding-card {\n\t\t\t\t\tpadding: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-title {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tfont-size: 18px;\n\t\t\n\t\t\t}\n\t\t\t.icon-edit {\n\t\t\t\tzoom: 1.3;\n\t\t\t}\n\t\t\tion-col {\n\t\t\t\tpadding: 5px 0px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t\t.left-col {\n\t\t\t\ttext-align: left;\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t}\n\t\t\t\n\t\t\t.right-col {\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\ttext-align: right;\n\t\t\t\t&.bold {\n\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.header-sliders {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px 0px;\n\t.step {\n\t\twidth: 33%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\t.line {\n\t\t\twidth: 100%;\n\t\t\theight: 5px;\n\t\t\t background-color: #D9D9D9;\n\t\t\t;\n\t\t\t&.selected {\n\t\t\t\tbackground-color: var(--ion-color-primary);\n\n\t\t\t\tanimation: pulse 2s infinite;\n\n\t\t\t}\n\t\t}\n\t\tp {\n\t\t\tpadding-top: 10px;\n\t\t}\n\t}\n}\n@keyframes pulse {\n\t0%, 100% {\n\t  background-color: var(--ion-color-primary);\n\t  opacity: 1;\n\t}\n\t50% {\n\t  background-color: var(--ion-color-primary);\n\t  opacity: 0.5;\n\t}\n  }\n.delivery-steps {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\t&__item {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: relative;\n\t\tion-icon {\n\t\t\twidth: 100px;\n\t\t\theight: 100px;\n\t\t}\n\t\tp,h3,h5 {\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tpadding: 10px;\n\n\t\t}\n\t\tp {\n\t\t\tfont-family: AppFont;\n\t\t\tpadding: 0px;\n\t\t}\n\t\th3,h5 {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t}\n\t\tp {\n\t\t\tfont-size: 12px;\n\t\t}\n\t\th5 {\n\t\t\tfont-size: 16px;\n\t\t}\n\t\th3 {\n\t\t\tfont-size: 18px;\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\t.map-block {\n\t\tmin-height: 0px;\n\t\n\t\topacity: 0;\n\t\tz-index: -1;\n\t\tmax-height: 0px;\n\t\tposition: relative;\n\t\t.show-time {\n\t\t\tposition: absolute;\n\t\t\ttop: 50px;\n\t\t\tbackground: white;\n\t\t\tpadding: 10px 20px;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t\tz-index: 999;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\t.status-show {\n\t\t\tposition: absolute;\n\t\t\tbottom: 50px;\n\t\t\tbackground: white;\n\t\t\tpadding: 10px 20px;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t\tz-index: 999;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\t&.hide-item {\n\t\t\tmin-height: 400px;\n\t\t\tmax-height: 400px;\n\t\t\topacity: 1;\n\t\tz-index: 1;\n\t\t}\n\t}\n}\n\n.map-container {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tmargin: 30px;\n\toverflow: hidden;\n  }\n\n  .map-frame {\n\tborder: 2px solid black;\n\theight: 100%;\n  }\n\n  #map-item {\n\theight: 100%;\n  }\n\n\n\n.verification-code {\n\tpadding: 18px 12px!important;\n\tborder: 1px solid #ED6958;\n\tion-row:first-child {\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n\tion-row {\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\tdiv {\n\t\tmin-width: 160px;\n\t\twidth: 55%;\n\t\tmax-width: 240px;\n\t\tborder: 1px solid #CBD5E1;\n\t\tborder-radius: 10px;\n\t\tmargin: 0 auto;\n\t\tpadding: 10px;\n\t\tletter-spacing: 5px;\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-align: center;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
